import { useState, useEffect, useRef } from 'react'
import { getUnitGroups } from 'store/actions/unitGroupsActions'

const useGetUnitGroups = (id = '') => {
  const mountedRef = useRef(true)
  const [unitGroups, setUnitGroups] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    getData(id)
    return () => {
      mountedRef.current = false
    }
  }, [])

  const getData = async (id = '') => {
    setLoading(true)
    try {
      const data = await getUnitGroups(id || '')
      if (!mountedRef.current) return null
      setUnitGroups(data)
      setLoading(false)
    } catch (err) {
      setLoading(false)
    }
  }

  return { loading, unitGroups, refetch: () => getData(id) }
}

export default useGetUnitGroups
